import Trans from 'next-translate/Trans'
import DistanceInKm from 'tennders-common/components/DistanceInKM'
import GCurrency from 'tennders-market/common/components/element/GCurrency'

export const OfferLine = ({ offer, title, bold }) => {
  const line = (
    <>
      {offer?.isMyOffer
        ? <Trans i18nKey="offer:yourOffer" />
        : title}
      {' : '}
      <GCurrency value={offer?.bid} />
      {offer?.paymentTerms ? (
        <>
          {` / ${offer?.paymentTerms} `}
          <Trans i18nKey="offer:days" />
        </>
      ) : null}
      {' / '}
      <DistanceInKm value={offer?.distance} />
      {` | ${offer?.date}`}
    </>
  )
  return (
    <div className="mb-8">
      {bold ? <strong>{line}</strong> : line}
    </div>
  )
}
